import React from 'react';
import { useNavigate } from 'react-router-dom';

function WhoAreWeSection() {
  const navigate = useNavigate();

  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
        {/* Image Section */}
        <div className="w-full md:w-1/2 animate-fade-in-left">
          <div className="bg-pink-200 p-6 rounded-lg transform transition-transform duration-300 hover:scale-105">
            <img
              src="/images/bg1.jpg"
              alt="Ceyone Foundations Team"
              className="w-full h-80 rounded-lg transition-opacity duration-300 hover:opacity-90"
            />
          </div>
        </div>

        {/* Text Section */}
        <div className="w-full md:w-1/2 text-left animate-fade-in-right">
          <h2 className="text-4xl font-bold text-gray-800 mb-4 transform transition-transform duration-300 hover:scale-105 hover:text-gray-900">
            Who Are We?
          </h2>
          <p className="text-gray-600 font-bold mb-2 transition-colors duration-300 hover:text-gray-800">
            Ceyone foundations is a Non-Government Organization established on October 10, 2013 under Indian trust act.
          </p>
          <p className="text-gray-600 font-bold mb-2 transition-colors duration-300 hover:text-gray-800">
            Ceyone Foundations is registered under the NITI aayog.
          </p>
          <p className="text-gray-600 mb-6 transition-colors duration-300 hover:text-gray-800">
            Ceyone foundations aims to promote skill development & social needed activities by catalyzing creation of large, quality PRO (Public Relation Office) vocational institutions.
          </p>
          <button onClick={() => navigate('/about')} className="bg-pink-100 text-pink-600 font-semibold py-2 px-6 rounded-full transition-all duration-300 hover:bg-pink-300 hover:text-pink-800 hover:scale-105">
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}

export default WhoAreWeSection;